import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import AboutMe from './pages/About/AboutMe';
import RecentWorks from './pages/Projects/RecentWorks';
function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path='/' exact><AboutMe /></Route>
          <Route path='/works'><RecentWorks></RecentWorks></Route>
        </Switch>
      </Router>
      <Footer />
      
    </div>
  );
}

export default App;
